import { useRef, useState } from 'react';
import {
  ArrowIcon,
  BathtubIcon,
  BedIcon,
  FavoritesIcon,
  SizeIcon,
} from '../../../assets/icons';

const PropertyGallery = ({ photosURL, thumbnailsURL, unitType, unitIndex }) => {
  const [imgIndex, setImageIndex] = useState(0);
  const refSlider = useRef(null);

  const scroll = (scrollOffset) => {
    refSlider.current.scrollLeft += scrollOffset;
  };

  return (
    <div className="property__gallery">
      <div className="property__gallery--main">
        <button
          className="gallery-btn left"
          onClick={() => {
            if (imgIndex <= 0) {
              setImageIndex(photosURL.length - 1);
            } else {
              setImageIndex((prevIndex) => prevIndex - 1);
            }
          }}
        >
          <ArrowIcon />
        </button>

        <div className="imgs-container">
          {photosURL.map((img, i) => (
            <img
              key={i}
              src={photosURL[i]}
              alt="img"
              style={{ transform: `translateX(${-imgIndex * 100}%)` }}
              loading={`${i < 3 ? 'eager' : 'lazy'}`}
            />
          ))}
        </div>

        <button
          className="gallery-btn right"
          onClick={() => {
            if (imgIndex >= photosURL.length - 1) {
              setImageIndex(0);
            } else {
              setImageIndex((prevIndex) => prevIndex + 1);
            }
          }}
        >
          <ArrowIcon />
        </button>
      </div>

      <div className="property__gallery--options">
        <div className="thumbnails">
          <button
            className="gallery-btn small left"
            onClick={() => scroll(-90)}
          >
            <ArrowIcon />
          </button>

          <div className="thumbs-container" ref={refSlider}>
            {thumbnailsURL.map((thumbnail, i) => (
              <div
                key={i}
                className={`thumb ${imgIndex === i ? 'active' : ''}`}
                onClick={() => setImageIndex(i)}
              >
                <img src={thumbnail} alt="thumbnail" />
              </div>
            ))}
          </div>

          <button
            className="gallery-btn small right"
            onClick={() => scroll(90)}
          >
            <ArrowIcon />
          </button>
        </div>

        <div className="favorites">
          <div className="line"></div>
          <FavoritesIcon />
          <div className="line"></div>
        </div>

        <div className="details">
          <div>
            <BedIcon />
            <p>{unitType[unitIndex].beds} Beds</p>
          </div>
          <div className="line"></div>
          <div>
            <BathtubIcon />
            <p>{unitType[unitIndex].baths} Baths</p>
          </div>
          <div className="line"></div>
          <div>
            <SizeIcon />
            <p>{unitType[unitIndex].size} m2</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PropertyGallery;
